import { createClient } from 'contentful';

import { ContentType } from 'types/ContentType';
import { isFeatureEnabled } from './features';

const CONTENTFUL_PREVIEW_TOKEN = 'qNKDMOqUTqXKeua-D40oq8v4sM-X9Q5P6lQLweitPrI';
const CONTENTFUL_PROD_TOKEN = 'cZzlj8Mm8HSRfPKkzR9LJgMSuch0_rl4XC1wBv_etSo';

const shouldUseContentfulPreview = isFeatureEnabled('CONTENTFUL_PREVIEW');

const client = createClient({
  space: 'i05x0cq9zz6m',
  accessToken: shouldUseContentfulPreview
    ? CONTENTFUL_PREVIEW_TOKEN
    : CONTENTFUL_PROD_TOKEN,
  ...(shouldUseContentfulPreview && {
    host: 'preview.contentful.com',
  }),
});

export const getEntries = async <T>(contentType: ContentType) => {
  return await client.getEntries<T>({
    content_type: contentType,
  });
};

export const getEntry = async <T>(id: string) => {
  return await client.getEntry<T>(id);
};

export default client;
